const T_PREFIX = "filtering";

export const filteringTrns = {
  title: `${T_PREFIX}.title`,

  searchPlaceholder: `${T_PREFIX}.search-placeholder`,

  minPlaceholder: `${T_PREFIX}.price-slider.min-placeholder`,
  maxPlaceholder: `${T_PREFIX}.price-slider.max-placeholder`,

  fromLabel: `${T_PREFIX}.price-slider.from-label`,
  toLabel: `${T_PREFIX}.price-slider.to-label`,
};

export const filteringLabelsTrns = {
  search: `${T_PREFIX}.labels.search`,
  minInvestment: `${T_PREFIX}.labels.min-investment`,
  listPrice: `${T_PREFIX}.labels.list-price`,
  industry: `${T_PREFIX}.labels.industry`,
  businessType: `${T_PREFIX}.labels.business-type`,
  employees: `${T_PREFIX}.labels.employees`,
  yearsOnTheMarket: `${T_PREFIX}.labels.years-on-the-market`,
  numberOfCustomers: `${T_PREFIX}.labels.number-of-customers`,
  annualTurnover: `${T_PREFIX}.labels.annual-turnover`,
  monthlyIncome: `${T_PREFIX}.labels.monthly-income`,
};

export const filteringButtonsTrns = {
  showLess: `${T_PREFIX}.buttons.show-less-btn`,
  showMore: `${T_PREFIX}.buttons.show-more-btn`,
  remove: `${T_PREFIX}.buttons.remove-filters`,
  filters: `${T_PREFIX}.buttons.filters`,
};

export const filteringOptionsTrns = {
  product: `${T_PREFIX}.options.business-type.product`,
  service: `${T_PREFIX}.options.business-type.service`,
  company: `${T_PREFIX}.options.business-type.company`,
};
